import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_CAPITAL_STATE_CONSTRUCTION}/etapas-bodegas-details`

export default ({ id }) => http.get(`${api}/${id}`)
